import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'

export function useRemoveUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (userId: string) => {
      const { error } = await supabase.rpc('remove_user_from_organization', {
        p_user_id: userId,
      })

      if (error) {
        // Map specific error codes to meaningful error messages
        if (error.message.includes('CANNOT_REMOVE_SELF')) {
          throw new Error('CANNOT_REMOVE_SELF')
        }
        if (error.message.includes('CANNOT_REMOVE_LAST_ADMIN')) {
          throw new Error('CANNOT_REMOVE_LAST_ADMIN')
        }
        if (error.message.includes('PERMISSION_DENIED')) {
          throw new Error('PERMISSION_DENIED')
        }
        if (error.message.includes('USER_NOT_FOUND')) {
          throw new Error('USER_NOT_FOUND')
        }
        throw error
      }
    },
    onSuccess: () => {
      // Invalidate organization users query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['organization-users'] })
    },
  })
}
